import { useEffect, useState } from "react"
import { useAtom } from "jotai"
// import loginUser from "@/hooks/usePostLogin";
import { loginUser } from "@/hooks/usePostLogin"
import { setStorage } from "@/common/storage"
import { userAtom } from "@/common/state"
import type { User } from "@/common/state"
import GoogleSignIn from "./GoogleSignIn"
// import FacebookSignIn from "./FacebookSignIn"

// import Visibility from "@mui/icons-material/Visibility"
// import VisibilityOff from "@mui/icons-material/VisibilityOff"
import {
  Box,
  // Box,
  // Button,
  // Divider,
  // IconButton,
  // InputAdornment,
  Stack,
  Typography,
  // Typography,
} from "@mui/material"
import { z } from "zod"
import { zodResolver } from "@hookform/resolvers/zod"
import { FieldError, useForm } from "react-hook-form"

// import LockIcon from "@mui/icons-material/Lock"
// import ControlledTextInput from "../controlledInputs/ControlledTextInput"
const loginFormData = z.object({
  email: z.string().email().min(1, "Please enter your email address."),
  password: z
    .string()
    .min(8, { message: "Password must be at least 8 characters long" }),
})

// Define TypeScript type based on the schema
export type LoginFormData = z.infer<typeof loginFormData>

const defaultValues: LoginFormData = {
  email: "",
  password: "",
}

const UserLogin = () => {
  const {
    handleSubmit,
    // control,
    formState: { errors },
  } = useForm<LoginFormData>({
    resolver: zodResolver(loginFormData),
    defaultValues: defaultValues,
  })

  const [user, setUser] = useAtom(userAtom)
  const [successMessage, setSuccessMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined
  )

  // show password button
  // const [showPassword, setShowPassword] = useState(false)
  // const handleClickShowPassword = () => setShowPassword(!showPassword)
  // const handleMouseDownPassword = () => setShowPassword(!showPassword)

  const onSubmit = async (data: LoginFormData) => {
    await loginUser({ email: data.email, password: data.password }).then(
      (res) => {
        if (res.message) {
          // setErrorMessage("")
          // setSuccessMessage(res.message)

          const newUserLogin = setStorage<User>("user", {
            displayName: res.displayName,
            profilePicture: "",
            capabilities: res.capabilities,
            expires: res.expires,
          })
          setUser(newUserLogin)
        } else if (res.error) {
          setSuccessMessage("")
          setErrorMessage(res.error)
        }
      }
    )
  }

  // Utility function to get the first error message with the field name
  const getFirstErrorMessage = (
    errors: Record<string, FieldError | undefined>
  ): string | undefined => {
    // console.log(errors);

    for (const [key, value] of Object.entries(errors)) {
      if (value) {
        return `${value.message}`
      }
    }
    return undefined
  }

  useEffect(() => {
    // handle errors
    const firstErrorMessage = getFirstErrorMessage(Object(errors))
    setErrorMessage(firstErrorMessage)
  }, [errors])
  return (
    <Stack>
      {/* Login through Google or Facebook */}

      <Stack sx={{ width: "100%", alignItems: "center" }}>
        <GoogleSignIn />
        {/* <FacebookSignIn /> */}
        <Box>
          <Typography>More Options Coming Soon!</Typography>
        </Box>
      </Stack>

      <form onSubmit={handleSubmit(onSubmit)}>
        <section
          className="modal-card-body"
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            paddingTop: "1rem",
          }}
        >
          <Box>
            {/* <div className="control has-icons-left has-icons-right">
              <ControlledTextInput
                control={control}
                formInputStyling={{ height: "54px", width: "100%" }}
                name="email"
                placeholder="Email Address"
                type="text"
                variant="outlined"
              />
            </div>

            <div className="control has-icons-left has-icons-right">
              <ControlledTextInput
                control={control}
                variant="outlined"
                name="password"
                placeholder="Password"
                type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                formInputStyling={{ height: "54px", width: "100%" }}
                startAdornment={
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              /> */}
            {/* </div>
            <Box sx={{ textAlign: "center", padding: "1rem" }}>
              {errorMessage && (
                <Typography variant="caption" color="text.warning">
                  {errorMessage}
                </Typography>
              )}
            </Box>
          </Box> */}

            {/* <Divider sx={{ mb: "1rem" }} />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="outlined"
            className="button is-success"
            type="submit"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="button is-success"
            type="submit"
          >
            Login
          </Button>*/}
          </Box>
        </section>
      </form>
    </Stack>
  )
}

export default UserLogin
